import style from "@/ui-modules/core/redux-form/styles/FormWidget.module.scss";

import { SEARCH_OPERATORS } from "../../../app-utils/rsql.js";
import { CELL_TYPE } from "../../../settings/settings.js";
import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";

interface NumberInputProps extends IAdvancedSearchFieldProps {
  value: string | number;
  placeholder: string;
  changeHandler: (arg0: string | number) => void;
}

function NumberInput(props: NumberInputProps) {
  return (
    <input
      value={props.value}
      type="number"
      className={style.input_widget}
      placeholder={props.placeholder}
      min={props.field.searchAttribute.minValue}
      max={props.field.searchAttribute.maxValue}
      step={"any"}
      onChange={(event: any) => props.changeHandler(event.currentTarget.value)}
      onBlur={props.onBlur}
      // TODO: Removed "autofocus" because of conflicts probably with react-aria:
      // The menu closes itself when the focus is on an input
      // autoFocus={props.autoFocus}

      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (!isValidNumericChar(event, props.field.searchAttribute.cellType)) {
          if (!event.ctrlKey) {
            event.preventDefault();
          }
        }
      }}
    />
  );
}

// check is mandatory for Firefox browsers
function isValidNumericChar(event: React.KeyboardEvent<HTMLInputElement>, cellType: string) {
  const keyCode: number = event.keyCode;
  const asInteger: boolean = cellType === CELL_TYPE.INTEGER;
  const asScientificNumber: boolean = cellType === CELL_TYPE.SCIENTIFIC;

  // Allow only 'e' for scientific notations
  if (asScientificNumber && keyCode === 0x45) {
    return true;
  }
  // do not allow the '.' for integers
  if (asInteger && (keyCode === 110 || keyCode === 190)) {
    return false;
  }
  // do not allow any letters (keycode in [65, 90]) or spaces (keycode in [32])
  if ((keyCode >= 0x41 && keyCode <= 0x5a) || keyCode === 0x20) {
    return false;
  }
  return true;
}

/**
 * Input field with type number in advanced search criteria.
 */
export default function AdvancedSearchNumber(props: IAdvancedSearchFieldProps) {
  return props.filterOperation.operator === SEARCH_OPERATORS.BETWEEN ? (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: props.verticalLayout ? "column" : "row",
        rowGap: props.verticalLayout ? 5 : null,
        columnGap: props.verticalLayout ? null : 5,
      }}
    >
      <NumberInput
        {...props}
        value={props.filterOperation.value as string | number}
        placeholder={"Enter min number"}
        changeHandler={(value) => props.onChangeState({ value }, false)}
      />
      <NumberInput
        {...props}
        value={props.filterOperation.value2}
        placeholder={"Enter max number"}
        changeHandler={(value) => props.onChangeState({ value2: value }, false)}
        autoFocus={false}
      />
    </div>
  ) : (
    <NumberInput
      {...props}
      value={props.filterOperation.value as string | number}
      placeholder={"Enter a number"}
      changeHandler={(value) => props.onChangeState({ value: value }, false)}
    />
  );
}
